import { Link } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BlogPost } from "@/content/blog";

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard = ({ post }: BlogCardProps) => {
  return (
    <Link to={`/blog/${post.slug}`}>
      <Card className="hover:shadow-lg transition-shadow h-full bg-gray-800 border-gray-700 hover:border-gray-600">
        <CardHeader>
          <p className="text-sm text-gray-400 mb-2">
            {format(parseISO(post.date), "MMMM d, yyyy")}
          </p>
          <CardTitle className="text-white">{post.title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-300 line-clamp-3">
            {post.excerpt || "No preview available"}
          </p>
        </CardContent>
      </Card>
    </Link>
  );
};

export default BlogCard;
